import { render } from "./RelatedPeople.vue?vue&type=template&id=5c5b4f9c&scoped=true&ts=true"
import script from "./RelatedPeople.vue?vue&type=script&lang=ts"
export * from "./RelatedPeople.vue?vue&type=script&lang=ts"

import "./RelatedPeople.vue?vue&type=style&index=0&id=5c5b4f9c&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c5b4f9c"]])

export default __exports__